// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonMessages = {
  copied: "Copied",
  copyFailed: "Copy failed",
  loading: "Loading...",
  requestFailed: "Request failed. Please try again later.",
  loadFailed: "Load failed",
  totalCount: "{count} items",
  selectedCount: "{count} selected",
  selectedAllCount: "{count} selected",
  selectedPartialCount:
    "Selected first {selected} items ({total} items match the current filters; the remainder is not selected)",
  idNumber: "ID #{id}",
} as const;
